import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  GET_SERVICE_CHANGE_DATES_INFO_PENDING,
  GET_SERVICE_CHANGE_DATES_INFO_FAILED,
  GET_SERVICE_CHANGE_DATES_INFO_FULFILLED,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"
import { MOCK_SERVICE_CHANGE_INFORMATION } from "utils-lib/mocks"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

export const pendingAC = () => ({
  type: GET_SERVICE_CHANGE_DATES_INFO_PENDING,
})

export const failedAC = () => ({
  type: GET_SERVICE_CHANGE_DATES_INFO_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_SERVICE_CHANGE_DATES_INFO_FULFILLED,
  payload: data,
})

export const getServiceChangeDatesInfo =
  (customerId, recommendationId) => (dispatch, getState) => {
    const api = `SERVICE_CHANGE_DATES`
    const template = URITemplate(urls.url[api])
    const state = getState()
    const locale = get(state, `siteLanguage.language`, ``)

    const url = MOCK_SERVICE_CHANGE_INFORMATION
      ? `${ssrWindow.origin}/mock/service-change-get-dates-info-response.json`
      : template.expand({
          customerId,
          userId: get(state, `userAccount.userDetails.userId`, ``),
          lang: locale,
        })

    const config = {
      method: `GET`,
      headers: {},
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)
      const fullURL = MOCK_SERVICE_CHANGE_INFORMATION
        ? url
        : `${url}&recommendationId=${recommendationId}`
      return getServiceChangeDatesHelper(fullURL, config, dispatch)
    })
  }

export const getServiceChangeDatesHelper = (url, config, dispatch) => {
  dispatch(pendingAC())

  return axios(url, config)
    .then((response) => {
      dispatch(fulfilledAC(response?.data?.data))
      return response?.data?.data
    })
    .catch(() => {
      dispatch(failedAC())
    })
}
